import {
  Color,
  List,
  Paragraph
} from '@eggplant/pattern-library'

const MostCommonErrorsInfo = () =>
  <>
    <Paragraph>
      <Color variant='theme-description-text'>
        The top 10 test case errors report provides valuable insights into the test cases that have encountered the highest number of errors within the applied filters at the dashboard level. This report helps you identify recurring errors and focus on areas that require attention.
      </Color>
      <br />
      <br />
      <Color variant='theme-description-text'>
        Key Features:
      </Color>
      <br />
    </Paragraph>
    <List variant='description'>
      <Paragraph>
        <Color variant='theme-description-text'>
          Error Frequency Analysis: Identify the top 10 test cases with the highest number of errors, allowing you to prioritize troubleshooting efforts effectively.
        </Color>
      </Paragraph>
      <Paragraph>
        <Color variant='theme-description-text'>
          Model or Suite Association: Each test case is associated with a specific model or suite, providing contextual information for targeted investigation.
        </Color>
      </Paragraph>
      <Paragraph>
        <Color variant='theme-description-text'>
          Detailed Test Case View: Access specific test cases directly from the report using the actions icon, enabling a focused examination of individual test case.
        </Color>
      </Paragraph>
      <Paragraph>
        <Color variant='theme-description-text'>
          Comprehensive Error Overview: Explore all errors within each specific test case to gain a deeper understanding of the encountered issues.
        </Color>
      </Paragraph>
    </List>
    <br />
    <Paragraph>
      <Color variant='theme-description-text'>
        With the top 10 test case errors report, you can efficiently address recurring errors, streamline debugging efforts, and enhance the overall quality and reliability of your testing process.
      </Color>
    </Paragraph>
  </>

export default MostCommonErrorsInfo
